module.exports = __webpack_public_path__ + "img/cnc-03-bg-trx-number.b752bf68.jpg";